export const RETINA_IMAGE_SUFFIX = '@2x';

export const ASSORTMENTS_MARKETING_PAGES_IMAGES = {
    'overview/check-in-ticket': {
        suffix: '.png',
        standard: 'a8761c',
        retina: '0c27c1',
    },
    'overview/event-chart--desktop': {
        suffix: '.png',
        standard: '697c9d',
        retina: '54a483',
    },
    'overview/event-chart--mobile': {
        suffix: '.png',
        standard: 'bba8b7',
        retina: '928415',
    },
    'overview/event-pages': {
        suffix: '.png',
        standard: 'cb40ab',
        retina: '7ad931',
    },
    'overview/hero-mobile': {
        suffix: '.jpg',
        standard: 'a6efec',
        retina: 'fcf4e0',
    },
    'overview/hero': {
        suffix: '.jpg',
        standard: 'a5c22a',
        retina: 'e7b3dc',
    },
    'overview/organizer-app--large': {
        suffix: '.png',
        standard: '3856d9',
        retina: '6c4d2a',
    },
    'overview/brand-checkout': {
        suffix: '.png',
        standard: 'feca1b',
        retina: '1c22b3',
    },
    'overview/brand-listing': {
        suffix: '.png',
        standard: '43459e',
        retina: '85ff37',
    },
    'overview/brand-website': {
        suffix: '.png',
        standard: 'f58552',
        retina: '84a6ec',
    },
    'overview/devices-create': {
        suffix: '.png',
        standard: 'cb5863',
        retina: '3df5b4',
    },
    'overview/img-devices-dashboard': {
        suffix: '.png',
        standard: '81cbd6',
        retina: 'fa02fb',
    },
    'overview/img-onsite-equipment': {
        suffix: '.jpg',
        standard: '40b240',
        retina: 'e90180',
    },
    'overview/img-onsite-manager': {
        suffix: '.jpg',
        standard: 'd58676',
        retina: '61cb2d',
    },
    'overview/img-onsite-staff': {
        suffix: '.jpg',
        standard: '701811',
        retina: 'c30859',
    },
    'overview/img-sm-dance': {
        suffix: '.png',
        standard: '19e26b',
        retina: '195d1d',
    },
    'overview/img-org-app--dashboard': {
        suffix: '.png',
        standard: 'eed83a',
        retina: '54dc5b',
    },
    'overview/img-org-app-scan': {
        suffix: '.png',
        standard: '6cf2f8',
        retina: '5eeb0d',
    },
    'overview/img-org-app--sell': {
        suffix: '.png',
        standard: '5a6d23',
        retina: '4a2335',
    },
    'overview/img-sm-epp': {
        suffix: '.png',
        standard: '09d797',
        retina: '052396',
    },
    'overview/img-sm-facebook': {
        suffix: '.png',
        standard: '5df2ca',
        retina: 'bf577b',
    },
    'overview/img-sm-google': {
        suffix: '.png',
        standard: 'f91444',
        retina: 'ab232c',
    },
    'overview/img-sm-millions': {
        suffix: '.png',
        standard: '943562',
        retina: '34688e',
    },
    'overview/img-sm-orgApp': {
        suffix: '.png',
        standard: 'c946c4',
        retina: '136939',
    },
    'package1/checkout': {
        suffix: '.jpg',
        standard: '52e4c0',
        retina: '9f8035',
    },
    'package1/facebook': {
        suffix: '.jpg',
        standard: 'f95c59',
        retina: '3e9e1e',
    },
    'package1/screenprinting': {
        suffix: '.jpg',
        standard: '10261f',
        retina: 'd28607',
    },
    'package1/experience-ticket': {
        suffix: '.png',
        standard: '12f638',
        retina: '431bcb',
    },
    'package1/simplify': {
        suffix: '.png',
        standard: '6e4200',
        retina: '885444',
    },
    'package1/brand--checkout': {
        suffix: '.jpg',
        standard: 'e1a104',
        retina: '50e4bf',
    },
    'package1/brand--crowdrise': {
        suffix: '.png',
        standard: '45da76',
        retina: '8dbed5',
    },
    'package1/brand--listing': {
        suffix: '.jpg',
        standard: '6b141b',
        retina: '6db657',
    },
    'package1/brand--ticket': {
        suffix: '.png',
        standard: '09ec2c',
        retina: '00c854',
    },
    'package1/essentials-hero-graphic': {
        suffix: '.png',
        standard: '4e5cdf',
        retina: '16a8bc',
    },
    'package2/audiences--desktop': {
        suffix: '.png',
        standard: 'c4bfb7',
        retina: '69ce67',
    },
    'package2/audiences--mobile': {
        suffix: '.png',
        standard: '2ad9c6',
        retina: 'be65b4',
    },
    'package2/experience-ticket': {
        suffix: '.png',
        standard: '12f638',
        retina: '431bcb',
    },
    'package2/simplify': {
        suffix: '.png',
        standard: '55c638',
        retina: '267040',
    },
    'package2/brand--ticket': {
        suffix: '.png',
        standard: 'c17e88',
        retina: '1a1803',
    },
    'package2/professional-hero-graphic': {
        suffix: '.png',
        standard: '9a1818',
        retina: '2dc5c6',
    },
    'package3/RFID': {
        suffix: '.jpg',
        standard: '1d5b81',
        retina: '55206c',
    },
    'package3/crowd': {
        suffix: '.jpg',
        standard: '91dbe7',
        retina: '375522',
    },
    'package3/staff': {
        suffix: '.jpg',
        standard: '699770',
        retina: '295254',
    },
    'package3/training': {
        suffix: '.jpg',
        standard: '5f69f6',
        retina: 'e61fa2',
    },
    'package3/stella-dot': {
        suffix: '.png',
        standard: 'f4f22e',
        retina: 'cc3e65',
    },
    'package3/simplify': {
        suffix: '.png',
        standard: 'ef92f6',
        retina: 'd3589e',
    },
    'package3/brand--simplify': {
        suffix: '.png',
        standard: '9c65f5',
        retina: '522549',
    },
    'package3/premium-hero-graphic': {
        suffix: '.png',
        standard: '5ba7b5',
        retina: 'fbb8a9',
    },
    'brand-logos/abradi': {
        suffix: '.png',
        standard: '260e17',
        retina: 'dd0050',
    },
    'brand-logos/snow-globe': {
        suffix: '.png',
        standard: '565a35',
        retina: '3cd59a',
    },
    'brand-logos/general-assembly': {
        suffix: '.png',
        standard: 'acda7d',
        retina: '79b1c9',
    },
    'brand-logos/moz': {
        suffix: '.png',
        standard: 'ee9488',
        retina: 'e25ff9',
    },
    'brand-logos/crescent-city': {
        suffix: '.png',
        standard: '04843e',
        retina: 'bfd8f4',
    },
    'brand-logos/ymca': {
        suffix: '.png',
        standard: '196de9',
        retina: 'c19dee',
    },
    'brand-logos/web-directions': {
        suffix: '.png',
        standard: 'cbbc42',
        retina: '0985fa',
    },
    'brand-logos/yoga-expo': {
        suffix: '.png',
        standard: '84dddb',
        retina: 'abb772',
    },
    'brand-logos/maker-faire': {
        suffix: '.png',
        standard: '9967f3',
        retina: '41deeb',
    },
    'brand-logos/awesome-inc': {
        suffix: '.png',
        standard: 'fe349c',
        retina: 'c2f3c6',
    },
    'brand-logos/dance-411': {
        suffix: '.png',
        standard: 'a72b19',
        retina: 'd1a57b',
    },
    'brand-logos/national-sawdust': {
        suffix: '.png',
        standard: 'dc0a2f',
        retina: '4ad2da',
    },
    'brand-logos/garlic-festival': {
        suffix: '.png',
        standard: 'fc3b3b',
        retina: 'fb83ec',
    },
    'brand-logos/assistem': {
        suffix: '.png',
        standard: 'a53d0c',
        retina: '150bdc',
    },
    'brand-logos/beer-in-cider': {
        suffix: '.png',
        standard: 'b871b7',
        retina: '8a4bf9',
    },
    'brand-logos/bits': {
        suffix: '.png',
        standard: '728b56',
        retina: '49eb2f',
    },
    'brand-logos/bottle-shop': {
        suffix: '.png',
        standard: '52166e',
        retina: '7d7d3f',
    },
    'brand-logos/casa': {
        suffix: '.png',
        standard: '61a8d0',
        retina: '25c7fa',
    },
    'brand-logos/ccia': {
        suffix: '.png',
        standard: '58317c',
        retina: 'f57f6d',
    },
    'brand-logos/chess': {
        suffix: '.png',
        standard: '727368',
        retina: 'd45ac1',
    },
    'brand-logos/conaacup': {
        suffix: '.png',
        standard: '9155d9',
        retina: '6870aa',
    },
    'brand-logos/drovet': {
        suffix: '.png',
        standard: 'ad462e',
        retina: 'df0f76',
    },
    'brand-logos/elegi': {
        suffix: '.png',
        standard: '07fdfc',
        retina: '19db53',
    },
    'brand-logos/forro': {
        suffix: '.png',
        standard: '4e2277',
        retina: 'd35648',
    },
    'brand-logos/games': {
        suffix: '.png',
        standard: 'd8278b',
        retina: '416704',
    },
    'brand-logos/gfny': {
        suffix: '.png',
        standard: '78bdc6',
        retina: 'efc97a',
    },
    'brand-logos/hernan': {
        suffix: '.png',
        standard: '011214',
        retina: '3ea512',
    },
    'brand-logos/loves-data': {
        suffix: '.png',
        standard: '83bb8c',
        retina: '03e850',
    },
    'brand-logos/mediar': {
        suffix: '.png',
        standard: '853448',
        retina: '85401b',
    },
    'brand-logos/newme': {
        suffix: '.png',
        standard: 'fbae67',
        retina: 'cb6a63',
    },
    'brand-logos/payoneer': {
        suffix: '.png',
        standard: '0d9210',
        retina: '1dbf03',
    },
    'brand-logos/plus': {
        suffix: '.png',
        standard: '6e8cb8',
        retina: '69143d',
    },
    'brand-logos/nacoes': {
        suffix: '.png',
        standard: 'f19dfb',
        retina: '44022d',
    },
    'brand-logos/queremos': {
        suffix: '.png',
        standard: '4d7b23',
        retina: 'ad3af7',
    },
    'brand-logos/rhythm': {
        suffix: '.png',
        standard: '15144b',
        retina: '4c52b6',
    },
    'brand-logos/sensedia': {
        suffix: '.png',
        standard: '93befa',
        retina: 'e9898a',
    },
    'brand-logos/shimano': {
        suffix: '.png',
        standard: '481351',
        retina: '10d5a3',
    },
    'brand-logos/silvana': {
        suffix: '.png',
        standard: '15c8aa',
        retina: '33e8fa',
    },
    'brand-logos/socialmediaweek': {
        suffix: '.png',
        standard: '6bb2fc',
        retina: '9f6026',
    },
    'brand-logos/superlogica': {
        suffix: '.png',
        standard: '9bd86a',
        retina: 'd5634c',
    },
    'brand-logos/tedx': {
        suffix: '.png',
        standard: '83dc4c',
        retina: '4d3b50',
    },
    'brand-logos/thieves': {
        suffix: '.png',
        standard: '379ba6',
        retina: '7ee781',
    },
    'brand-logos/tmx': {
        suffix: '.png',
        standard: '2cf3e2',
        retina: '672399',
    },
    'brand-logos/toa': {
        suffix: '.png',
        standard: '8ea1c5',
        retina: '173d7f',
    },
    'brand-logos/trianons': {
        suffix: '.png',
        standard: 'a4c408',
        retina: '966917',
    },
    'brand-logos/UNSW': {
        suffix: '.png',
        standard: '98c4fd',
        retina: '2d834b',
    },
    'brand-logos/valley': {
        suffix: '.png',
        standard: '433bb7',
        retina: '7c3364',
    },
    'brand-logos/walker': {
        suffix: '.png',
        standard: 'ba7c36',
        retina: '290fb7',
    },
    'brand-logos/xletix': {
        suffix: '.png',
        standard: '51557e',
        retina: '7b62c3',
    },
    'brand-logos/yahyahs': {
        suffix: '.png',
        standard: '4ffb54',
        retina: 'a64c38',
    },
    'brand-logos/zum': {
        suffix: '.png',
        standard: '694dec',
        retina: '967a74',
    },
    'pricing/logo-basico': {
        suffix: '.png',
        standard: 'c75c2d',
        retina: '4f6533',
    },
    'pricing/logo-essentials': {
        suffix: '.svg',
        standard: 'ac2f26',
    },
    'pricing/logo-professional': {
        suffix: '.svg',
        standard: 'eb57ad',
    },
    'pricing/logo-premium': {
        suffix: '.svg',
        standard: '036646',
    },
    'pricing/logo-contact-sales': {
        suffix: '.svg',
        standard: '8d0b2f',
    },
    'pricing/logo-contact-sales-spanish': {
        suffix: '.svg',
        standard: 'a6e4b8',
    },
    'pricing/spanish--logo-basico': {
        suffix: '.svg',
        standard: '0871ca',
    },
    'pricing/spanish--logo-profesional': {
        suffix: '.svg',
        standard: 'ff7d37',
    },
};
